import { signal } from "@preact/signals-react"

export const profileSignal = signal({})
export const profileLoadedSignal = signal(false)
export const profileErrorSignal = signal(null)
export const profileCcSchemaSignal = signal(null)

export const profileListSignal = signal([])
export const profileListLoadedSignal = signal(false)
export const profileListErrorSignal = signal(null)